import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Box,
  CircularProgress,
  Typography,
  Link as MuiLink,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { STATUS_KEYS } from '../../helpers/options';

const FileProcessingCard = props => {
  const {
    status,
    pendingText,
    fileId,
    resolvedText,
    errorText,
    fileResultUrl,
  } = props;

  const { t } = useTranslation(['common', 'promptbar']);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {status === STATUS_KEYS.PENDING && (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={20} thickness={3} color="secondary" />
            <Typography component="p" sx={{ fontWeight: 'bold' }}>
              {pendingText}
            </Typography>
          </Box>
          <Box>
            <Typography component="p">
              {t(
                'You can close this page and download the result later using the link',
              ) + ':'}{' '}
              <strong>
                <Link to={fileId} className="MuiLink">
                  {window.location.href}/{fileId}
                </Link>
              </strong>
            </Typography>
          </Box>
        </>
      )}

      {status === STATUS_KEYS.RESOLVED && fileResultUrl && (
        <>
          <Typography component="p" sx={{ fontWeight: 'bold' }}>
            {resolvedText}
          </Typography>
          <MuiLink
            href={process.env.REACT_APP_MEMAS_CORE + '/' + fileResultUrl}
            underline="always"
            download
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 15px',
              backgroundColor: 'var(--color-green-80)',
              borderRadius: '8px',
            }}
            color="textPrimary"
          >
            <CheckCircleIcon color="success" />
            {t('Download the result file')}
          </MuiLink>
        </>
      )}

      {status === STATUS_KEYS.REJECTED && (
        <>
          <Typography component="p" sx={{ fontWeight: 'bold' }} mb={3}>
            {errorText}
          </Typography>
        </>
      )}
    </Box>
  );
};

FileProcessingCard.propTypes = {
  status: PropTypes.string.isRequired,
  pendingText: PropTypes.string.isRequired,
  resolvedText: PropTypes.string.isRequired,
  errorText: PropTypes.string.isRequired,
  fileId: PropTypes.string.isRequired,
  fileResultUrl: PropTypes.string,
};

export default FileProcessingCard;
